import { render } from "./ArticlesList.vue?vue&type=template&id=6f9989a4&ts=true"
import script from "./ArticlesList.vue?vue&type=script&lang=ts"
export * from "./ArticlesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__